import { ImageView as CommonImageView, type ImageViewProps } from '@monorepo/common';

function ImageView({ src, alt, isFreeSize, isCircled, style, loading, objectFit, dataTestId }: ImageViewProps) {
  return (
    <CommonImageView
      src={src}
      alt={alt}
      isFreeSize={isFreeSize}
      isCircled={isCircled}
      style={style}
      loading={loading}
      objectFit={objectFit}
      dataTestId={dataTestId}
    />
  );
}

export default ImageView;
